import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatashareService } from 'src/app/services/datashare.service';
import { LocalUtilService } from 'src/app/services/local-util.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent {

  constructor(
    private translate: TranslateService, 
    public dataShare: DatashareService,
    private localUtil: LocalUtilService) { }

  setLocale(loc: string) {
    this.dataShare.setLocal('locale', loc);
    this.translate.use(loc);
    window.location.reload();
  }

  cssForLocale(loc: string) {
    this.localUtil.setDefaultLang(this.dataShare.getLocal('locale'));
    return this.dataShare.getLocal('locale') == loc ? 'text-primary fw-bold' : 'text-dark';
  }

}
